import { connect } from 'react-redux';
import ResultScope from '../components/result_scope';
import { toggleFullLeaderboard } from '../actions/event_index';
import { selectIsManagerSite } from '../selectors';
import { EMPTY_ARRAY } from '../utils/empty';

// Scope-level table data (cut line, section lines, totals, columns) is
// selected by LeaderboardTableContainer; this only keeps what the wrapper
// chrome itself needs.
const mapStateToProps = (state, ownProps) => {
  const eventId = String(ownProps.eventId);
  const isManagerSite = selectIsManagerSite(state);
  const eventState = state.event[eventId];

  return {
    showFullLeaderboard: eventState.showFullLeaderboard,
    favorites: isManagerSite ? EMPTY_ARRAY : (eventState.favorites || EMPTY_ARRAY),
    isManagerSite,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleFullLeaderboard: (eventId) => dispatch(toggleFullLeaderboard(eventId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResultScope);
